import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.css';

const YesNoStatistic = ({ questions, color }) => {
    const [yesCount, noCount] = useMemo(() => {
        return [questions[0].reviews.length, questions[1].reviews.length];
    }, [questions]);

    const lineWidth = useMemo(() => {
        return yesCount + noCount === 0 ? 0 : (noCount * 100) / (yesCount + noCount);
    }, [yesCount, noCount]);

    return (
        <div className="statistic__yes-no">
            <span
                className={classNames('statistic__yes-no-counter', {
                    'statistic__yes-no-counter--active': lineWidth >= 50,
                })}
            >
                {noCount}
            </span>
            <div
                className={classNames('statistic__yes-no-button', {
                    'statistic__yes-no-button--active': lineWidth >= 50,
                })}
            >
                NO
            </div>
            <div className="statistic__line">
                <div
                    style={{
                        width: `${lineWidth}%`,
                        backgroundColor: `${color}`,
                        height: '100%',
                        border: '2px solid #ffffff',
                    }}
                />
            </div>
            <div
                className={classNames('statistic__yes-no-button', {
                    'statistic__yes-no-button--active': lineWidth <= 50,
                })}
            >
                YES
            </div>
            <span
                className={classNames('statistic__yes-no-counter', {
                    'statistic__yes-no-counter--active': lineWidth <= 50,
                })}
            >
                {yesCount}
            </span>
        </div>
    );
};

YesNoStatistic.propTypes = {
    questions: PropTypes.array.isRequired,
    color: PropTypes.string.isRequired,
};

export default React.memo(YesNoStatistic);
